import { createAsyncThunk } from '@reduxjs/toolkit';

import { TagService } from '../../services';

export const fetchAllTags = createAsyncThunk('tag/fetchAllTags', async (params, { rejectWithValue }) => {
  try {
    const response = await TagService.getAllTags(params);

    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to fetch all tags');
  }
});

export const fetchTags = createAsyncThunk('tag/fetchTags', async (params, { rejectWithValue }) => {
  try {
    const response = await TagService.fetchTags(params);

    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to fetch tags');
  }
});

export const fetchTag = createAsyncThunk('tag/fetchTag', async (id, { rejectWithValue }) => {
  try {
    const response = await TagService.fetchTag(id);

    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to fetch tag');
  }
});

export const searchTags = createAsyncThunk('tag/searchTags', async (params, { rejectWithValue }) => {
  try {
    const response = await TagService.searchTags(params);

    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to fetch tags');
  }
});

export const createTag = createAsyncThunk('tag/createTag', async (data, { rejectWithValue }) => {
  try {
    const response = await TagService.addTag(data);

    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to create tag');
  }
});

export const deleteTags = createAsyncThunk('tag/deleteTags', async (ids, { rejectWithValue }) => {
  try {
    await TagService.deleteTags(ids);

    return ids;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to delete tags');
  }
});
